import * as React from 'react';
import { createPortal } from 'react-dom';

import { useFocusSlot } from './zone';

/**
 * A page's own bar, drawn in place of its shell's navigation for as long as the page is mounted —
 * the Advisor Portal's focus mode (the two-portals design, §3.3). The survey keeps the lockup and
 * swaps the portal's entries for its name, whose it is, the save state and "Finish later".
 *
 * A portal into an element the shell keeps, rather than a bar the page draws itself or a node
 * handed up through state. Drawn by the page, the bar would sit under the address prompt the shell
 * draws below its own; handed up, every keystroke's save state would re-render the shell and, with
 * it, the route outlet the page lives in. Portalled, what is drawn is still the page's — its state,
 * its handlers, its one `[data-save-state]` — and only its place in the document is the shell's.
 *
 * Where the zone has no bar to give (a frame drawn inside another screen, a zone whose shell keeps
 * no slot), nothing is drawn: the bar is the shell's chrome, and a page without that shell has none.
 */
export function FocusBar({ children }: { children: React.ReactNode }) {
  const slot = useFocusSlot();
  return slot ? createPortal(children, slot) : null;
}
